export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/~/angularfire2/auth/index.js
// module id = ../../../../angularfire2/auth/index.js
// module chunks = 4